<template>
    <div
        class="min-w-full text-lg text-transparent walled-teaser bg-clip-text bg-gradient-to-b from-slate-500 to-white">
        <slot name="teaser"></slot>
    </div>
    <div class="relative max-w-4xl mx-auto my-8 border rounded-lg shadow-2xl" :class=cssClasses()>

        <div class="relative overflow-hidden bg-electric-600 rounded-l-lg md:absolute md:left-0 md:h-full md:w-1/3">

            <img class="object-cover w-full h-full mt-0" :src=imgUrl() alt="">

            <svg viewBox="0 0 926 676" aria-hidden="true"
                class="absolute -bottom-24 left-24 w-[57.875rem] transform-gpu blur-[118px]">
                <path fill="url(#60c3c621-93e0-4a09-a0e6-4c228a0116d8)" fill-opacity=".4"
                    d="m254.325 516.708-90.89 158.331L0 436.427l254.325 80.281 163.691-285.15c1.048 131.759 36.144 345.144 168.149 144.613C751.171 125.508 707.17-93.823 826.603 41.15c95.546 107.978 104.766 294.048 97.432 373.585L685.481 297.694l16.974 360.474-448.13-141.46Z">
                </path>
                <defs>
                    <linearGradient id="60c3c621-93e0-4a09-a0e6-4c228a0116d8" x1="926.392" x2="-109.635" y1=".176"
                        y2="321.024" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#776FFF"></stop>
                        <stop offset="1" stop-color="#FF4694"></stop>
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <div class="relative max-w-3xl mx-auto">
            <div class="pb-4 pl-6 md:ml-auto md:w-2/3">
                <div v-if="subscriptionType === 'non-member'">
                    <div class="px-8 space-y-6">
                        <p
                            class="mt-8 mb-3 text-5xl font-extrabold tracking-tight font-display text-clay-950 sm:text-4xl">
                            <span class="block font-thin text-electric-600 text-md">Hello Stranger!</span>
                        </p>
                        <div class="mt-2 text-lg font-medium text-gray-700">
                            <slot name="non-member">
                                <p v-if="contentFor ===  ContentFor.AtLeastBasic">
                                    <a href="/signup">Join the StageAgent community</a>
                                    <slot name="content-title">to unlock amazing theatre resources!</slot>
                                </p>
                                <p v-if="contentFor ===  ContentFor.ProOnly">
                                    <a href="/signup">Sign up for StageAgent PRO</a>
                                    <slot name="content-title">to unlock amazing theatre resources!</slot>
                                </p>
                            </slot>
                        </div>
                    </div>
                    <div class="px-8 mt-8 space-y-3 text-center">
                        <a :href="`/signup?redirect=${redirectUrl()}`"
                            class="block w-full px-3 py-2 text-sm font-semibold rounded-md shadow-sm bg-electric-600 text-white hover:bg-electric-700 focus-visible:outline-offset-2 focus-visible:outline-clay-600 ">Sign
                            Up</a>
                        <p>
                            <a :href="`/login?redirect=${redirectUrl()}`"
                                class="text-sm font-semibold text-gray-700 hover:text-gray-900 sm:mt-0 ">Already a
                                Member? <span class="underline">Log in</span></a>
                        </p>
                    </div>
                </div>

                <div v-if="subscriptionType === 'basic'">
                    <div class="px-8 space-y-6">
                        <p class="text-5xl font-extrabold tracking-tight font-display text-clay-950 sm:text-4xl">
                            <span class="block pt-6 font-thin text-electric-600 text-md ">Read More </span> Upgrade to
                            PRO
                        </p>
                        <div class="mt-2 text-lg font-medium text-gray-700">
                            <slot name="basic">
                                <p>
                                    <a href="/membership/upgrade">Upgrade to PRO</a>
                                    <slot name="content-title">to unlock amazing theatre resources!</slot>
                                </p>
                            </slot>
                        </div>
                    </div>
                    <div class="px-8 mt-8 space-y-3 text-center">
                        <a class="block w-full px-3 py-2 text-sm font-semibold rounded-full shadow-sm bg-gradient-to-r from-electric-500 via-electric-800 to-electric-600 bg-electric-600 text-white hover:bg-electric-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-600"
                            :href="`/membership/upgrade?redirect=${redirectUrl()}`">Upgrade</a>
                    </div>
                </div>


            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, PropType, Ref, ref} from "vue";
import {store} from "@/store";

enum ContentFor {
    AtLeastBasic = 'AtLeastBasic',
    ProOnly = 'ProOnly'
}

const props = defineProps({
    contentFor: {
        type: String as PropType<ContentFor>,
        default: 'AtLeastBasic'
    }
});

const contentFor: ContentFor = props.contentFor;

const subscriptionType = computed(() => {
    switch(store.saUserSession.subscriptionType) {
        case 'free' || 'basic':
            return 'basic';
        case 'pro':
            return 'pro';
        default:
            return 'non-member';
    }
})

const redirectUrl = () => {
  return window.location.href.substring(window.location.origin.length);
}
const imgUrl = () => {
    return `/public/assets/img/walled-off-cta-${contentFor.toString().toLowerCase()}-subscription-${subscriptionType.value}.jpg`;
}
const cssClasses = () => {
    return `${contentFor.toString().toLowerCase()} subscription-${subscriptionType.value}`;
}

</script>